import React, { useRef } from 'react';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import NewNav from '../components/NewNav';
import Footer from '../components/Footer';

import qh_new1 from '../images/qh_new1.jpg';
import qh_new2 from '../images/qh_new2.jpg';
import qh_new3 from '../images/qh_new3.jpeg';
import qh_new4 from '../images/qh_new4.jpeg';
import qh_new5 from '../images/qh_new5.jpeg';
import qh_new6 from '../images/qh_new6.jpeg';

import bannerImage from '../images/qh-logo.jpg';

function Product() {
  const dropdownRef = useRef(null); // dropdown target ref

  const scrollToDropdown = () => {
    dropdownRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <div className="product-wrapper-page">
        <NewNav />

        {/* News & Events Section */}
        <div className="container my-4">
          <Container fluid>
            <Row>
              {/* <Col
                md={4}
                className="d-flex align-items-center justify-content-center text-white"
                style={{
                  height: '85%',
                  minHeight: '226px',
                  backgroundColor: '#002147',
                }}
              >
                <h1 style={{ fontSize: '3rem' }}>News & Events</h1>
              </Col> */}
              {/* <Col md={8} className="p-0">
                <imgQ
                  src={bannerImage}
                  alt="News Banner"
                  style={{ width: '90%', height: '88%', objectFit: 'cover' }}
                />
              </Col> */}
            </Row>
          </Container>
        </div>

        {/* Carousel Section */}
        <div className="container my-4" ref={dropdownRef}>
          <Carousel interval={3000} fade>
            <Carousel.Item>
              <img
                className="d-block mx-auto w-64 h-auto rounded-lg shadow-md"
                src={qh_new1}
                alt="Product 1"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block mx-auto w-64 h-auto rounded-lg shadow-md"
                src={qh_new2}
                alt="Product 2"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block mx-auto w-64 h-auto rounded-lg shadow-md"
                src={qh_new3}
                alt="Product 3"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block mx-auto w-64 h-auto rounded-lg shadow-md"
                src={qh_new4}
                alt="Product 4"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block mx-auto w-64 h-auto rounded-lg shadow-md"
                src={qh_new5}
                alt="Product 5"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block mx-auto w-64 h-auto rounded-lg shadow-md"
                src={qh_new6}
                alt="Product 6"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="container my-4">
          <Container fluid>
            <Row>
              <Col
                md={12}
                className="d-flex align-items-center justify-content-center text-white"
                style={{
                  height: '85%',
                  minHeight: '15px',
                  backgroundColor: '#002147',
                }}
              >
                <h1 style={{ fontSize: '3rem' }}>Latest News</h1>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Clickable Image + Text */}
        <div className="container my-4" onClick={scrollToDropdown} style={{ cursor: 'pointer' }}>
          <Container fluid>
            <Row>
              <Col
                md={4}
                className="d-flex flex-column align-items-center justify-content-center text-white p-3"
                style={{
                  height: '85%',
                  minHeight: '15px',
                  backgroundColor: '#002147',
                }}
              >
                <img
                  src={qh_new1}
                  alt="Ceremony"
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '8px',
                    marginBottom: '15px',
                  }}
                />
                <div className="text-center">
                  <h5>
                    Qianghui Mingyuan Technology Manufacturing Park Roof Ceiling Ceremony
                  </h5>
                  <p>May 16, 2025</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Product;
